<div class="workspace-container">
  <ng-template ezPanelType />
</div>